var l={modal:"lds-modal",modalContent:"lds-modal--modal-content",subTitle:"lds-modal--sub-title",sm:"lds-modal--sm",lg:"lds-modal--lg",xl:"lds-modal--xl"};export{l as default};
